import Vue from "vue";

const components = {
  BaseInput: () => import("./Base/BaseInput"),
  BaseTextarea: () => import("./Base/BaseTextarea"),
  BaseSelect: () => import("./Base/BaseSelect"),
  BaseButton: () => import("./Base/BaseButton"),
  BaseCheckbox: () => import("./Base/BaseCheckbox"),
  Logo: () => import("./Logo"),
  Typography: () => import("./Typography"),
  IconSvg: () => import("./IconSvg"),
  Avatar: () => import("./Avatar"),
  Dropdown: () => import("./Dropdown"),
  ProgressIndicator: () => import("./ProgressIndicator"),
  LoadingBar: () => import("./LoadingBar"),
  ErrorBar: () => import("./ErrorBar"),
  Modal: () => import("./Modal"),
  HoverText: () => import("./HoverText"),
};

Object.entries(components).forEach(([name, component]) =>
  Vue.component(name, component)
);
